import React from 'react';
import { motion } from 'framer-motion';
import FormComponent from '../../generic/FormComponent/FormComponent';
import TextInput from '../../generic/TextInput/TextInput';

import styles from './PregnantInnerForm.module.scss';
import Select from '../../generic/Select/Select';

const PregnantInnerForm = ({
  babyConnect,
  state,
  control,
  errors,
  onClick,
  setCheckoutSection,
}) => {
  const [filter, setFilter] = React.useState('');

  const handleChange = React.useCallback(
    (event) => {
      setFilter(state.date.prioDay || event.currentTarget.value);
    },
    [filter],
  );

  return (
    <form className={styles.form} onSubmit={onClick}>
      <h2 className={styles.title}>Zwangerschap</h2>

      <div className={styles.input}>
        <motion.div layout>
          <FormComponent
            control={control}
            name="midwife"
            friendlyName={'Verloskundige'}
            rules={{
              required: !babyConnect,
            }}
            defaultValue={ babyConnect && 'Niet van toepassing voor babyconnect' ||  state.data.midwife || ''}
            render={(props) => (
              <TextInput
                disabled={babyConnect}
                wide
                required={!babyConnect}
                type="text"
                error={errors.midwife}
                label={'Verloskundige'}
                {...props}
              />
            )
            }
          />
        </motion.div>
        <motion.div layout>
          {errors.midwife && (
            <p>{errors.midwife.message}</p>
          )}
        </motion.div>
      </div>

      <div className={styles.input}>
        <motion.div layout>
          <FormComponent
            control={control}
            name="maternity"
            friendlyName={'Kraamzorg'}
            rules={{
              required: !babyConnect,
            }}
            defaultValue={babyConnect && 'Niet van toepassing voor babyconnect' ||  state.data.maternity || ''}
            render={(props) => (
              <TextInput
                disabled={babyConnect}
                wide
                required={!babyConnect}
                error={errors.maternity}
                label={'Kraamzorg'}
                {...props}
              />
            )
            }
          />
        </motion.div>
        <motion.div layout>
          {errors.maternity && (
            <p>{errors.maternity.message}</p>
          )}
        </motion.div>
      </div>

      <div className={styles.input}>
        <motion.div layout>
          <FormComponent
            control={control}
            name="pregDate"
            friendlyName={'Uitgerekende datum?'}
            rules={{
              required: !babyConnect,
            }}
            defaultValue={babyConnect && '0' ||  state.data.pregDate || ''}
            render={(props) => (
              <TextInput
                disabled={babyConnect}
                wide
                required={!babyConnect}
                type="date"
                error={errors.pregDate}
                label={'Uitgerekende datum?'}
                {...props}
              />
            )
            }
          />
        </motion.div>
        <motion.div layout>
          {errors.pregDate && (
            <p>{errors.pregDate.message}</p>
          )}
        </motion.div>
      </div>

      <div className={styles.input}>
        <motion.div layout>
          <FormComponent
            control={control}
            name="pregCount"
            friendlyName={'Hoeveelste zwangerschap?'}
            rules={{
              required: !babyConnect,
            }}
            defaultValue={babyConnect && '0' ||  state.data.pregCount || ''}
            render={(props) => (
              <TextInput
                disabled={babyConnect}
                wide
                required={!babyConnect}
                type="number"
                error={errors.pregCount}
                label={'Hoeveelste zwangerschap?'}
                {...props}
              />
            )
            }
          />
        </motion.div>
        <motion.div layout>
          {errors.pregCount && (
            <p>{errors.pregCount.message}</p>
          )}
        </motion.div>
      </div>

      <div className={styles.formGroup}>
        <div className={styles.input}>
          <motion.div layout>
            <FormComponent
              control={control}
              name="found"
              friendlyName={'Gevonden Via'}
              rules={{
                required: false,
              }}
              defaultValue={state.data.found || ''}
              render={(props) => (
                <Select
                  onChange={handleChange}
                  label={'Gevonden Via'}
                  defaultValue={''}
                  {...props}
                >
                  <option value={'Social Media'}>Via social media</option>
                  <option value={'Mond op mond'}>Mond op mond reclame</option>
                </Select>
              )
              }
            />
          </motion.div>
          <motion.div layout>
            {errors.found && (
              <p>{errors.found.message}</p>
            )}
          </motion.div>
        </div>

        <div className={styles.input}>
          <motion.div layout>
            <FormComponent
              control={control}
              name="other"
              friendlyName={'Anders'}
              rules={{
                required: false,
              }}
              defaultValue={state.data.other || ''}
              render={(props) => (
                <TextInput
                  wide
                  error={errors.other}
                  label={'Anders'}
                  {...props}
                />
              )
              }
            />
          </motion.div>
          <motion.div layout className={styles.error}>
            {errors.other && (
              <p>{errors.other.message}</p>
            )}
          </motion.div>
        </div>
      </div>

      <div className={styles.controls}>
        <button onClick={setCheckoutSection} className='button button--tertiary'>Terug</button>
        <input className='button button--secondary' type="submit"  value="Akkoord en doorgaan"/>
      </div>
    </form>
  )
}

export default PregnantInnerForm;